import React from 'react'

export const Arrow2Svg = ({ rotate = 0 }: { rotate?: number }) => {
  const transform = `rotate(${rotate} 12 12)`
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd" transform={transform}>
        <circle cx="12" cy="12" r="12" fill="#46AAE9" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          stroke="#FFF"
          d="M17 13.042l-.667.672-4.332-4.37-4.334 4.37L7 13.042 12 8z"
        />
      </g>
    </svg>
  )
}
